<template>
  <v-layout row wrap grid-list-lg>
    <v-flex xs12>

    <v-card>
      <v-card-title primary-title>
        <p class="headline mb-0">Convert WMS, WFS, Vector- and Raster-Files to the format you need</p>
      </v-card-title>
      <v-card-text>
        <v-list two-line subheader>
          <v-subheader>
            Choose the Conversion you would like:
          </v-subheader>
          <navigation v-for="geo in geoTypes" :item="geo" :key="geo.shortName" showUsage></navigation>
        </v-list>

      </v-card-text>
    </v-card>
    </v-flex>

    <conversion-results></conversion-results>
  </v-layout>
</template>
<script>
  import Navigation from '@/components/Navigation';
  import GeoResults from '@/components/converter/output/ConversionResults';
  import geoTypes from '@/components/converter/helpers/geoTypes';

  export default {
    name: 'welcome',
    components: {
      navigation: Navigation,
      'conversion-results': GeoResults,
    },
    data() {
      return {
        geoTypes,
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Welcome.vue